import { useState } from 'react';
import '../assets/css/galeria.css';
import Card from './Card';
import { listaDestacados, listaCompleta } from '../db';


function Galeria(){

    const [destacados, setDestacados]=useState(listaDestacados)
    
    const verMas=()=>{
        setDestacados(listaCompleta)
    }


    return(
        <>
            <div className='container__titulo' >
                <h1 className='titulo'>Algunos de nustros trabajos</h1>
            </div>
            <div className='galeria'>
                {destacados.map(destacados=><Card image={destacados}/>)}
            </div>
            <div style={{display:"flex", justifyContent:"center"}}><a onClick={verMas} class="ov-btn-grow-box">Ver Más</a></div><br></br>
        </>
    )
}

export default Galeria;